import React, { useEffect, useState } from "react";
import "../Styles/VerticalCarousel.css";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

function VerticalCarousel() {
  const [activeID, setActiveID] = useState(0);
  const [wrapperStyle, setWrapperStyle] = useState({
    backgroundImage: `url('${data[0].img}')`,
    backgroundSize: "fit",
  });
  const [buttonLink, setButtonLink] = useState();
  const [buttonHover, setButtonHover] = useState(false);
  const [buttonStyle, setButtonStyle] = useState({
    color: "#ffffff",
  });
  // Add state for controlling automatic slide changing
  const [autoSlideInterval, setAutoSlideInterval] = useState(null);

  const _changeActive = (id) => {
    setActiveID(id);
    setWrapperStyle({
      backgroundImage: `url('${data[id].img}')`,
    });
  };

  const _buttonColour = () => {
    if (!buttonHover) {
      setButtonHover(true);
      setButtonStyle({
        color: data[activeID].colour,
      });
      setButtonLink(data[activeID].link);
    } else {
      setButtonHover(false);
      setButtonStyle({
        color: "#ffffff",
      });
    }
  };

  useEffect(() => {
    // Start the automatic slide changing interval
    const interval = setInterval(() => {
      const nextSlideID = (activeID + 1) % data.length;
      _changeActive(nextSlideID);
    }, 5000); // Change slide every 5 seconds

    // Store the interval ID to clear it on component unmount
    setAutoSlideInterval(interval);

    return () => {
      // Clear the interval on component unmount
      clearInterval(autoSlideInterval);
    };
  }, [activeID]); // Run effect whenever the activeID changes

  return (
    <section
      className="wrapper"
      style={{ ...wrapperStyle, minHeight: "500px" }}
    >
      <Panel
        selectors={
          <Selectors
            data={data}
            activeID={activeID}
            _changeActive={_changeActive}
          />
        }
        data={data[activeID]}
        buttonStyle={buttonStyle}
        _buttonColour={_buttonColour}
        buttonLink={buttonLink}
      />
    </section>
  );
}

function Panel(props) {
  const navigate = useNavigate();
  return (
    <aside className="panel">
      <Grid container gap={0}>
        <Grid item xs={1}>
          {props.selectors}
        </Grid>
        <Grid xs={11}>
          <h2 className="panel-header">{props.data.header}</h2>
          <p className="panel-info">{props.data.body}</p>
          <button
            className="panel-button"
            onClick={() => navigate(props.buttonLink)}
            style={props.buttonStyle}
            onMouseEnter={props._buttonColour}
            onMouseLeave={props._buttonColour}
          >
            View More
          </button>
        </Grid>
      </Grid>
    </aside>
  );
}

function Selectors(props) {
  const _handleClick = (id) => {
    if (id !== props.activeID) {
      props._changeActive(id);
    }
  };

  return (
    <div className="selectors">
      {props.data.map((item) => (
        <Selector
          key={item.id}
          id={item.id}
          _handleClick={_handleClick}
          _changeActive={props._changeActive}
          activeID={props.activeID}
        />
      ))}
    </div>
  );
}

function Selector(props) {
  const componentClass =
    props.activeID === props.id ? "selector active" : "selector";

  useEffect(() => {});

  return (
    <div
      className={componentClass}
      onClick={() => props._handleClick(props.id)}
    ></div>
  );
}

const data = [
  {
    id: 0,
    header: "Hand Bags",
    body: "Long lasting, stylish classy bags...",
    colour: "#242846",
    img: "Images/display/handbag01.jpg",
    link: "/category/hand_bags",
  },
  {
    id: 1,
    header: "Jewelry",
    body: "Trendy accessories for all occassions...",
    colour: "#ba9077",
    img: "Images/Jewelry.jpg",
    link: "/category/jewelry",
  },
  {
    id: 2,
    header: "Shoes",
    body: "Footwear affordable and made just for you ;)",
    colour: "#1ABC9C",
    img: "Images/display/shoe01.jpg",
    link: "/category/shoes",
  },
  {
    id: 3,
    header: "Purses",
    body: "Unique and classy money purses...",
    colour: "#C0392B",
    img: "Images/display/purse01.jpg",
    link: "/category/purses",
  },
  {
    id: 4,
    header: "Used Bags",
    body: "Strong, durable and good looking bags...",
    colour: "#513B56",
    img: "Images/display/bags01.jpg",
    link: "/category/used_bag_packs",
  },
];

export default VerticalCarousel;
